import { Component } from 'ng-metadata/core';

import './banner.scss';


/**
 * @ngdoc directive
 * @name mwContentStreamBanner
 * @module mw.components.contentStream
 * @description
 * `<mw-content-stream-banner>` is responsible for display information under the content stream header based on your use case
 *  Just add the `<mw-content-stream-banner>` to the `<mw-content-stream-header>`  to have it attach
 *  and get the sticky attributes as well when using the sticky directive
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-stream-banner> Look at my super dope banner! </mw-content-stream-banner>
 * </hljs>
 */
@Component({
    selector: 'mw-content-stream-banner',
    template: `
        <div class="mw-content-stream-banner">
            <ng-transclude> </ng-transclude>
        </div>
    `,
    legacy: {
        transclude: true
    }
})
export class BannerComponent {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/banner/banner.component.ts